import UnderlinedInput from "@material-ui/core/Input";
export default UnderlinedInput;

export let styles = theme => ({
  root: {
    padding: "9px 0 8px",
  },
  input: {
    padding: "unset"
  },
  formControl: {
    "label + &": {
      marginTop: "14px"
    }
  },
  underline: {
    "&:after": {
      borderColor: theme.palette.primary.main
    },
    "&:hover:not(.Mui-disabled):before": {
      borderBottom: `1px solid ${theme.palette.primary.main}`
    },
    "&.Mui-error:not(.Mui-focused):before": {
      borderBottom: `1px solid ${theme.palette.error.main}`
    },
    "&.Mui-error:not(.Mui-focused):after": {
      transform: "scaleX(0)",
      borderBottom: `2px solid ${theme.palette.error.main}`
    }
  }
});
